export default "__VITE_ASSET__D$BxMZZh__"